import { codigo_cliente, tipo_relacao, refresh_token, relacoes as Relacoes, relacao_id, condominio_id, jwt as global_jwt } from "./auth";

export default {
    setAgora(state, agora) {
        state.agora = agora
    },
    setDrawer(state, drawer) {
        state.drawer = !!drawer;
    },
    setCliente(state, cliente) {
        const { codigo, nome, cpfCnpj: cpf, senha, contato, endereco } = cliente;
        if (contato) {

            Object.keys(contato).forEach(key => {
                if ('string' != typeof contato[key]) {                
                    contato[key] = '';
                }
            });
            Object.keys(endereco).forEach(key => {
                if ('string' != typeof endereco[key]) {                
                    endereco[key] = '';
                }
            });
        }
        state.cliente = { codigo, nome, cpf, senha, contato, endereco };
        localStorage.setItem('cliente', JSON.stringify({ cpf, senha, codigo }));
        codigo_cliente.value = codigo
    },
    setRelacoes(state, relacoes) {
        state.relacoes = [...relacoes];
        localStorage.setItem('relacoes', JSON.stringify(relacoes));

        Relacoes.value = state.relacoes
        
        const relacao = state.relacoes[state.relacao_id]
        tipo_relacao.value = relacao?.tipoRelacao||''
        
    },
    setVinculoId(state, vinculo_id) {
        state.vinculo_id = vinculo_id;
        localStorage.setItem('vinculo_id', vinculo_id);
    },
    setRelacaoId(state, id) {
        state.relacao_id = +id;
        localStorage.setItem('relacao_id', +id);
        
        relacao_id.value = id
        const relacao = state.relacoes[state.relacao_id]
        tipo_relacao.value = relacao?.tipoRelacao || ''
        
    },
    setCondominioId(state, id) {
        state.condominio_id = +id;
        localStorage.setItem('condominio_id', +id);
        condominio_id.value = id
        
    },
    setContratoId(state, contrato_id) {
        state.contrato_id = +contrato_id;
        localStorage.setItem('contrato_id', +contrato_id);
    },
    setImovelId(state, imovel_id) {
        state.imovel_id = +imovel_id;
        localStorage.setItem('imovel_id', +imovel_id);
    },
    setRefreshToken(state, token) {
        state.refresh_token = token;
        
        if (null === token) {
            localStorage.removeItem('refresh_token');
        } else {

            localStorage.setItem('refresh_token', token);
        }

        refresh_token.value = token
    },
    setJwt(state, jwt) {
        state.jwt = jwt;
        global_jwt.value = jwt
    },
    setExpiresAt(state, expiresAt) {
        state.expiresAt = expiresAt;
    },
    setLoading(state, loading) {
        state.loading = loading;
    }
};